import { Component, OnInit, NgModule } from '@angular/core';
import { AppSettings } from './providers/app-settings';
import { Router } from '@angular/router';
import { WindowRef } from './providers/window-ref';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  authenticated = false;
  inactivityHandler: any;
  activityEvents: string[] = ['onload', 'onmousemove', 'onmousedown', 'onclick', 'onscroll', 'onkeypress'];
  warningCountdown: number = null;
  countdownInterval: any;
  inactivityTime = 300000;

  constructor(private router: Router, private winRef: WindowRef, private appSettings: AppSettings) {
  }

  ngOnInit() {
    this.appSettings.isUserLoggedIn.subscribe(value => {
      this.authenticated = value;
      if (!this.authenticated) {
        this.clearInactivityHandler();
        this.router.navigate(['/login']);
      } else {
        this.idleLogout();
      }
    });
  }

  clearInactivityHandler() {
    this.activityEvents.forEach((event) => {
      this.winRef.nativeWindow[event] = null;
    });
    clearTimeout(this.inactivityHandler);
  }

  idleLogout() {
    this.activityEvents.forEach((event) => {
      this.winRef.nativeWindow[event] = this.resetTimer.bind(this);
    });
    this.resetTimer();
  }

  logout() {
    this.appSettings.apiHeaders.set('X-Access-Token', null);
    this.appSettings.setLoginStatus(false);
    this.router.navigate(['/login']);
  }

  promptLogout() {
    this.clearInactivityHandler();
    this.warningCountdown = 15;
    this.countdownInterval = setInterval(() => {
      this.warningCountdown--;
      if (this.warningCountdown < 0) {
        clearInterval(this.countdownInterval);
        this.logout();
      }
    }, 1000);
  }

  resetTimer() {
    this.warningCountdown = null;
    clearInterval(this.countdownInterval);
    clearTimeout(this.inactivityHandler);
    this.inactivityHandler = setTimeout(this.promptLogout.bind(this), this.inactivityTime);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.component.ts